export default __webpack_public_path__ + "static/media/01_Kom_Golden Buoy.6ed0c930.jpg";